/* eslint-disable no-param-reassign */
export default (state, { meta }) => {
  const page = meta.arg.options?.page ?? 0;
  state.streams.loading = true;
  if (page === 0) {
    state.streams.list = {};
  }
};
